import React, { useState, useEffect } from "react";

interface TimeSelectorProps {
  titles: { [key: string]: string };
  timePeriod: string;
  handleClick?: (timePeriod: string) => void;
}

const TimeSelector = ({
  titles,
  timePeriod,
  handleClick,
}: TimeSelectorProps) => {
  const [selected, setSelected] = useState(timePeriod);

  useEffect(() => {
    setSelected(timePeriod);
  }, [timePeriod]);

  const onTitleClick = (title: string) => {
    setSelected(title);
    if (handleClick) handleClick(title);
  };

  return (
    <div
      style={{
        marginLeft: "10px",
        backgroundColor: "#e6e6e6",
        width: "fit-content",
      }}
    >
      {Object.keys(titles).map((title) => (
        <button
          key={title}
          onClick={() => onTitleClick(title)}
          style={{
            backgroundColor: selected === title ? "#132445" : "#e6e6e6",
            color: selected === title ? "white" : "black",
            border: "none",
            padding: "6px 6px",
            margin: "4px",
            fontSize: "14px",
            cursor: selected === "" ? "not-allowed" : "pointer",
            pointerEvents: selected === "" ? "none" : "auto",
          }}
        >
          {title}
        </button>
      ))}
    </div>
  );
};

export default TimeSelector;
